import { graphql } from '__generated__';

import { useQueryStable } from '@/hooks/useQueryStable';

export const GetModelQueryUsage = graphql(/* GraphQL */ `
  query ModelQueryUsage(
    $environmentId: BigInt!
    $end: Date!
    $start: Date!
    $uniqueId: String!
  ) {
    performance(environmentId: $environmentId) {
      oldestQueryHistoryDate
      resourceQueryHistory(end: $end, start: $start, uniqueId: $uniqueId) {
        date
        totalCount
      }
    }
    environment(id: $environmentId) {
      modelQueryHistoryState {
        state
      }
    }
  }
`);

type ModelQueryUsageParams = {
  environmentId?: number;
  startDate: string;
  endDate: string;
  uniqueId: string;
  pause?: boolean;
};

export const useModelQueryUsage = ({
  environmentId = 0,
  startDate,
  endDate,
  uniqueId,
  pause,
}: ModelQueryUsageParams) => {
  const query = useQueryStable({
    query: GetModelQueryUsage,
    variables: {
      environmentId,
      start: startDate,
      end: endDate,
      uniqueId,
    },
    pause: pause || !environmentId || !startDate || !endDate || !uniqueId,
  });

  return query;
};
